<template>
  <div class="error-box">{{ message }}</div>
</template>

<script>
export default {
  name: "DsInputErrorBox",
  props: {
    message: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/_variables.scss";

.error-box {
  display: block;
  min-height: 21px;
  padding-top: 2px;
  margin-top: 0px !important;
  font-size: $font-small-size;
  color: $red-error-color;
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-input-error-box.vue